module.exports = __webpack_public_path__ + "img/IMG-Tanques2.0b264b06.png";